/** ************************ Core Interface Start ****************************** */

import {
  INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, ExtraOptions
} from '@bingads-webui-react/notification-center';

export { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, ExtraOptions };

export interface IScope {
  values: {
    aid: string | number;
    cid: string | number;
    uid: string | number | null;
    adGroupId: string | number | null;
    campaignId: string | number | null;
  };
  location: {
    hash: string;
    pathname: string;
    search: string;
  };
}

export enum NotificationEntityType {
  accountSuspended = 12,
  adBlockWarning = 26,
  budgetOpportunity = 5,
  disapproved = 7,
  import = 1,
  incompatibleBrowsers = 22,
  introBingAdsforioS = 20,
  keywordOpportunity = 6,
  maintenance = 11,
  migration = 4,
  none = 0
}

export type EnvType = 'OldUI' | 'New UI';
